import "../styles/tailwind.css";
import "../scripts/load-components.js";

console.log("index entry loaded");
